import { Link } from 'react-router-dom';

const SupportConfirmation = () => {
  return (
    <div className="container-custom max-w-3xl">
      <div className="bg-white border border-gray-200 rounded-lg p-8">
        <div className="text-center mb-8">
          <svg className="w-20 h-20 mx-auto mb-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h1 className="text-3xl font-bold mb-4 text-gray-900">
            Message Sent Successfully!
          </h1>
          <p className="text-lg text-gray-600">
            Thank you for contacting us. We have received your message.
          </p>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-8">
          <h2 className="font-bold text-green-900 mb-3">What Happens Next?</h2>
          <ol className="space-y-3 text-green-800 list-decimal list-inside">
            <li className="ml-4">Our support team will review your message</li>
            <li className="ml-4">We will respond to your email within 24 hours</li>
            <li className="ml-4">For urgent matters, please check your email regularly</li>
            <li className="ml-4">If you provided a reference number, we'll prioritize your request</li>
          </ol>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
          <h3 className="font-bold text-blue-900 mb-3">Need Immediate Assistance?</h3>
          <p className="text-blue-800 mb-4">
            For quick answers to common questions, please visit our FAQ section before waiting for a response.
          </p>
          <Link
            to="/faq"
            className="inline-flex items-center justify-center px-6 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors"
          >
            Visit FAQ Page
          </Link>
        </div>

        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-8">
          <h3 className="font-bold text-yellow-900 mb-2">Tips for Faster Response</h3>
          <ul className="space-y-2 text-yellow-800 text-sm">
            <li>• Include any reference numbers from previous transactions</li>
            <li>• Provide as much detail as possible about your inquiry</li>
            <li>• Make sure your email address is correct</li>
            <li>• Check your spam folder for our response</li>
          </ul>
        </div>

        <div className="flex flex-col md:flex-row gap-4">
          <Link
            to="/"
            className="flex-1 btn-primary text-center"
          >
            Back to Home
          </Link>
          <Link
            to="/services"
            className="flex-1 btn-secondary text-center"
          >
            View Services
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SupportConfirmation;
